import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down-simple-filled",
  "use": "icon-arrow-down-simple-filled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down-simple-filled\">\n<path d=\"M7 10L12 15L17 10H7Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol